import Modal from 'react-bootstrap/Modal'
import { useLocation, useParams } from 'react-router-dom'
import useSetJustAddPay from './hooks/useSetJustAddPay'
import useGetUsers from 'modules/fund/tabs/hooks/useGetUsers'

interface IModalProps {
    show: boolean
    onHide: () => void
}
const AddJustPayForOtherModal = ({ show, onHide }: IModalProps) => {
    const { state } = useLocation()
    const { moneyPool } = useParams()
    const { refetch } = useGetUsers(moneyPool)
    const { mutate } = useSetJustAddPay(refetch)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" px-6 py-3 text-center">
                <p>
                    تایید، به منزله دریافت وجه از پرداخت کننده و نگهداری آن نزد
                    مدیر صندوق است.
                </p>
                <hr className=" my-2" />
                <p
                    className=" text-green-1"
                    onClick={() => {
                        onHide()
                        const payload: IPayloadForJustAdd = {
                            poolShip: Number(state?.item?.id),
                            amount: Number(state?.item?.unpaid_portion),
                            moneyPool: Number(moneyPool),
                        }
                        mutate(payload)
                    }}
                >
                    تایید
                </p>
                <hr className=" my-2" />
                <p onClick={onHide}>بازگشت</p>
            </div>
        </Modal>
    )
}

export default AddJustPayForOtherModal
